import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from '../header';
import Footer from '../footer';
import './career.css';
function Career() {
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        telephone: "",
        age: "",
        expertise: "",
        experience: "",
        position: "",
    });

    const [errors, setErrors] = useState({
        firstName: "",
        lastName: "",
        email: "",
        telephone: "",
        age: "",
        expertise: "",
        experience: "",
        position: "",
    });

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        let errorMessage = "";

        if (name === "firstName" || name === "lastName") {
            const nameRegex = /^[a-zA-Z\s]*$/;
            errorMessage = !nameRegex.test(value) ? "Name can only contain letters" : "";
        } else if (name === "email") {
            const emailRegex = /^[^\s@]+@gmail\.(com|in)$/i;
            errorMessage = !emailRegex.test(value) ? "Invalid email address" : "";
        } else if (name === "telephone") {
            const numberRegex = /^\d*$/;
            errorMessage = !numberRegex.test(value) ? "Telephone number must contain only numeric" : "";
        } else if (name === "age") {
            const ageValue = parseInt(value);
            errorMessage = isNaN(ageValue) || ageValue < 18 || ageValue > 100 ? "Please enter a valid age (between 18 and 100)" : "";
        }

        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: errorMessage });
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        // Check for errors before submitting
        const formErrors = Object.values(errors).filter((error) => error !== "");
        if (formErrors.length > 0) {
            alert("Please fix the errors before submitting the form.");
            return;
        }

        const { firstName, lastName, email, telephone, age, expertise, experience, position } = formData;

        const mailtoLink = `mailto:career@moovgroup.com?subject=CAREER SUBMISSION FORM &body=Name: ${firstName} ${lastName}%0D%0AEmail: ${email}%0D%0ATelephone: ${telephone}%0D%0AAge: ${age}%0D%0AExpertise: ${expertise}%0D%0ARelevant Experience: ${experience}%0D%0APosition: ${position}`;

        window.location.href = mailtoLink;


        setFormData({
            firstName: "",
            lastName: "",
            email: "",
            telephone: "",
            age: "",
            expertise: "",
            experience: "",
            position: "",
        });

    };

    return (

        <>
            <div className="boxed_wrapper" id="career">
                <Helmet>
                    <title>Current Job Openings - Moov Group</title>
                    <meta name="description" content=" " />
                    <meta property="og:title" content="Current Job Openings - Moov Group" />
                    <meta property="og:description" content="" />
                    <meta property="og:image" content="../../images/moovgroup-office.webp" />
                    <link rel="canonical" href="https://www.moovgroup.com/career" />
                    <link rel="alternate" href="https://www.moovgroup.com/career" hreflang="en-GB" />
                </Helmet>
                <Header />
                <section className="appointment-area career-bg">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-6 col-lg-6">
                                <div className="map-content-box">
                                    <div className="sec-title">
                                        <div className="title">We are Hiring</div>
                                    </div>
                                    <div className="job-listing">
                                        <div className="sec-title">
                                            <p>Current Job Openings</p>
                                        </div>

                                        <div className="job-card">
                                            <h4><span className="title-tag">01</span>Project Co-ordinator</h4>
                                            <p><span>Qualification :</span> Diploma/Degree in Engineering, Business, or related field.</p>
                                            <p><span>Experience :</span> - Prior experience in project coordination or a similar role is preferred.</p>
                                            <p><span>Job Description:</span></p>
                                            <ul>
                                                <li>Assist in planning and scheduling project activities.</li>
                                                <li>Coordinate between site teams, suppliers, and management.</li>
                                                <li>Prepare and maintain project documents, reports, and records.</li>
                                                <li>Monitor project milestones and provide regular status updates to management.</li>
                                                <li>Follow up on material deliveries, approvals, and deadlines.</li>
                                                <li>Arrange meetings and prepare minutes of meeting (MoM).</li>
                                                <li>Support Project Manager with daily tasks and communication.</li>
                                            </ul>
                                        </div>

                                        <div className="job-card">
                                            <h4><span className="title-tag">02</span>Estimation Engineer</h4>
                                            <p><span>Qualification :</span> Degree/Diploma in Civil / Mechanical / Electrical Engineering (as applicable).</p>
                                            <p><span>Experience :</span> Experience in estimation and quantity take-off.</p>
                                            <p><span>Job Description:</span></p>
                                            <ul>
                                                <li>Prepare cost estimates, BOQs, and material take-offs from drawings.</li>
                                                <li>Analyze project specifications and technical requirements.</li>
                                                <li>Request and compare supplier/subcontractor quotations.</li>
                                                <li>Coordinate with project and procurement teams during tender preparation.</li>
                                                <li>Prepare tender documents, cost summaries, and pricing sheets.</li>
                                                <li>Assist in value engineering and cost optimization.</li>
                                                <li>Maintain updated price lists and cost databases.</li>
                                            </ul>
                                        </div>

                                        <div className="job-card">
                                            <h4><span className="title-tag">03</span>Site Engineer</h4>
                                            <p><span>Qualification :</span> Any Graduate</p>
                                            <p><span>Experience :</span> 2 years of GCC experience in construction site supervision.</p>
                                            <p><span>Job Description:</span></p>
                                            <ul>
                                                <li>Supervise day-to-day site activities to ensure work is carried out as per drawings, specifications, and schedule.</li>
                                                <li>Coordinate with subcontractors, suppliers, and project managers to ensure timely progress.</li>
                                                <li>Prepare and update daily site reports, progress records, and documentation.</li>
                                                <li>Perform site inspections and ensure compliance with safety rules and quality standards.</li>
                                                <li>Assist in material estimation, quantity take-off, and monitoring material usage on site.</li>
                                                <li>Resolve technical issues and provide engineering support to the site team.</li>
                                                <li>Attend regular site meetings and communicate project updates.</li>
                                                <li>Ensure all work complies with local regulations and company policies.</li>
                                            </ul>
                                        </div>

                                        <div className="job-card">
                                            <h4><span className="title-tag">04</span>Purchase Officer</h4>
                                            <p><span>Qualification :</span> Any Graduate</p>
                                            <p><span>Experience :</span> 0 - 2 years (Ladies with Residence Visa preferred)</p>
                                            <p><span>Job Description:</span></p>
                                            <ul>
                                                <li>Identify and manage suppliers, negotiate agreements, and maintain strong relationships.</li>
                                                <li>Process purchases, generate orders, and ensure timely delivery.</li>
                                                <li>Analyze costs, negotiate pricing, and optimize expenses.</li>
                                                <li>Monitor inventory levels, manage stock, and ensure availability.</li>
                                                <li>Maintain purchase records, invoices, and cost analysis reports.</li>
                                                <li>Ensure quality standards, compliance, and ethical procurement.</li>
                                                <li>Collaborate with internal teams to align purchasing needs.</li>
                                                <li>Evaluate supplier performance and implement improvements.</li>
                                            </ul>
                                        </div>

                                        <div className="job-card">
                                            <h4><span className="title-tag">05</span>Site Engineer (Interior Fitout)</h4>
                                            <p><span>Qualification :</span>Engineering Degree/Diploma (any stream)</p>
                                            <p><span>Experience :</span> 0 - 2 years</p>
                                            <p><span>Job Description:</span></p>
                                            <ul>
                                                <li>Supervise site activities for timely project execution</li>
                                                <li>Coordinate with contractors, suppliers, and clients.</li>
                                                <li>Ensure work aligns with approved drawings and quality standards.</li>
                                                <li>Enforce site safety protocols and maintain documentation.</li>
                                            </ul>
                                            <p><span>Skills:</span></p>
                                            <ul>
                                                <li>Site supervision & project coordination.</li>
                                                <li>Strong understanding of construction drawings & quality control.</li>
                                                <li>Effective communication & multitasking abilities.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-xl-6 col-lg-6" id="form">
                                <div className="sec-title">
                                    <div className="title1">Register your  <span className="fontweight">dream job</span>
                                    </div>
                                </div>
                                <div className="appointment-box wow slideInRight" data-wow-delay="300ms" data-wow-duration="1500ms">
                                    <div className="title-box">
                                        <h2>Career</h2>
                                        <span>Leave your information below / send your cv to <a href="mailto:career@moovgroup.com">career@moovgroup.com</a></span>
                                    </div>
                                    <div className="appointment">
                                        <form className="appointment-form" onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-xl-6">
                                                    <div className="single-box">
                                                        <input type="text" name="firstName" placeholder="First Name" required value={formData.firstName} onChange={handleInputChange} />
                                                        {errors.firstName && <p style={{ color: "red", fontSize: "12px" }} className="error">{errors.firstName}</p>}
                                                    </div>
                                                </div>
                                                <div className="col-xl-6">
                                                    <div className="single-box">
                                                        <input type="text" name="lastName" placeholder="Last Name" required value={formData.lastName} onChange={handleInputChange} />
                                                        {errors.lastName && <p style={{ color: "red", fontSize: "12px" }} className="error">{errors.lastName}</p>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <div className="single-box">
                                                        <input type="email" name="email" placeholder="Email" required value={formData.email} onChange={handleInputChange} />
                                                        {errors.email && <p style={{ color: "red", fontSize: "12px" }} className="error">{errors.email}</p>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-6">
                                                    <div className="single-box">
                                                        <input type="text" name="telephone" placeholder="Telephone" required value={formData.telephone} onChange={handleInputChange} />
                                                        {errors.telephone && <p style={{ color: "red", fontSize: "12px" }} className="error">{errors.telephone}</p>}
                                                    </div>
                                                </div>
                                                <div className="col-xl-6">
                                                    <div className="single-box">
                                                        <input type="text" name="age" placeholder="Age" required value={formData.age} onChange={handleInputChange} />
                                                        {errors.age && <p style={{ color: "red", fontSize: "12px" }} className="error">{errors.age}</p>}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-6">
                                                    <div className="single-box">
                                                        <input type="text" name="expertise" placeholder="Expertise" required value={formData.expertise} onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                                <div className="col-xl-6">
                                                    <div className="single-box">
                                                        <input type="text" name="experience" placeholder="Relevent Experience" required value={formData.experience} onChange={handleInputChange} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <div className="single-box">
                                                        <input type="text" name="position" list="positionList" placeholder="Select Position" required value={formData.position} onChange={handleInputChange} />
                                                        <datalist id="positionList">
                                                            <option value="Project Co-ordinator" />
                                                            <option value="Estimation Engineer" />
                                                            <option value="Site Engineer" />
                                                            <option value="Purchase Officer" />
                                                            <option value="Site Engineer" />
                                                        </datalist>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <div className="single-box">
                                                        <button className="btn-one" type="submit">Submit Here<span className="flaticon-next"></span></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
}

export default Career;